// @ts-nocheck


// This file was generated by [tauri-specta](https://github.com/oscartbeaumont/tauri-specta). Do not edit this file manually.

/** user-defined commands **/


export const commands = {
async listMicrophoneDevices() : Promise<string[]> {
    return await TAURI_INVOKE("plugin:listener|list_microphone_devices");
},
async checkMicrophoneAccess() : Promise<boolean> {
    return await TAURI_INVOKE("plugin:listener|check_microphone_access");
},
async checkSystemAudioAccess() : Promise<boolean> {
    return await TAURI_INVOKE("plugin:listener|check_system_audio_access");
},
async requestMicrophoneAccess() : Promise<null> {
    return await TAURI_INVOKE("plugin:listener|request_microphone_access");
},
async requestSystemAudioAccess() : Promise<null> {
    return await TAURI_INVOKE("plugin:listener|request_system_audio_access");
},
async openMicrophoneAccessSettings() : Promise<null> {
    return await TAURI_INVOKE("plugin:listener|open_microphone_access_settings");
},
async openSystemAudioAccessSettings() : Promise<null> {
    return await TAURI_INVOKE("plugin:listener|open_system_audio_access_settings");
},
async getMicMuted() : Promise<boolean> {
    return await TAURI_INVOKE("plugin:listener|get_mic_muted");
},
async setMicMuted(muted: boolean) : Promise<null> {
    return await TAURI_INVOKE("plugin:listener|set_mic_muted", { muted });
},
async getSpeakerMuted() : Promise<boolean> {
    return await TAURI_INVOKE("plugin:listener|get_speaker_muted");
},
async setSpeakerMuted(muted: boolean) : Promise<null> {
    return await TAURI_INVOKE("plugin:listener|set_speaker_muted", { muted });
},
async subscribe(channel: TAURI_CHANNEL<SessionEvent>) : Promise<null> {
    return await TAURI_INVOKE("plugin:listener|subscribe", { channel });
},
async unsubscribe(channel: TAURI_CHANNEL<SessionEvent>) : Promise<null> {
    return await TAURI_INVOKE("plugin:listener|unsubscribe", { channel });
},
async startSession(sessionId: string) : Promise<null> {
    return await TAURI_INVOKE("plugin:listener|start_session", { sessionId });
},
async stopSession() : Promise<null> {
    return await TAURI_INVOKE("plugin:listener|stop_session");
},
async pauseSession() : Promise<null> {
    return await TAURI_INVOKE("plugin:listener|pause_session");
},
async resumeSession() : Promise<null> {
    return await TAURI_INVOKE("plugin:listener|resume_session");
},
async getState() : Promise<string> {
    return await TAURI_INVOKE("plugin:listener|get_state");
},
async setAwsCredentialExpiration(expiresAtMs: number) : Promise<null> {
    return await TAURI_INVOKE("plugin:listener|set_aws_credential_expiration", { expiresAtMs });
}
}

/** user-defined events **/


export const events = __makeEvents__<{
statusEvent: StatusEvent
}>({
statusEvent: "plugin:listener:status-event"
})

/** user-defined constants **/



/** user-defined types **/

export type AudioSource = "Unknown" | "Mic" | "Speaker" | "Both"
export type DiarizationChunk = { start: number; end: number; speaker: number; confidence: number | null }
export type ListenInputChunk = { audio: number[] }
export type ListenOutputChunk = { transcripts: TranscriptChunk[]; diarizations: DiarizationChunk[] }
export type ListenParams = { language: string; static_prompt: string; dynamic_prompt: string }
export type SessionEvent = ({ type: "started" } & SessionEventStarted) | ({ type: "stopped" } & SessionEventStopped) | { type: "paused" } | { type: "resumed" } | { type: "silence" } | ({ type: "timelineView" } & SessionEventTimelineView) | ({ type: "audioAmplitude" } & SessionEventAudioAmplitude) | { type: "credentialExpired" }
export type SessionEventAudioAmplitude = { mic: number; speaker: number }
export type SessionEventStarted = { seconds: number }
export type SessionEventStopped = { reason: string }
export type SessionEventTimelineView = { timeline: TimelineView }
export type StatusEvent = "inactive" | "running_active" | "running_paused"
export type SttVendor = "WebSocket" | "Deepgram" | "AwsTranscribe"
export type TimelineView = { items: TimelineViewItem[] }
export type TimelineViewItem = { start: number; end: number; speaker: number; text: string; confidence: number; is_final: boolean | null; vendor: SttVendor; audio_source: AudioSource | null }
export type TranscriptChunk = { start: number; end: number; text: string; confidence: number | null; is_final: boolean | null; vendor: SttVendor }

/** tauri-specta globals **/

import type {
	Channel as TAURI_CHANNEL} from "@tauri-apps/api/core";
import {
	invoke as TAURI_INVOKE
} from "@tauri-apps/api/core";
import * as TAURI_API_EVENT from "@tauri-apps/api/event";
import { type WebviewWindow as __WebviewWindow__ } from "@tauri-apps/api/webviewWindow";

type __EventObj__<T> = {
	listen: (
		cb: TAURI_API_EVENT.EventCallback<T>,
	) => ReturnType<typeof TAURI_API_EVENT.listen<T>>;
	once: (
		cb: TAURI_API_EVENT.EventCallback<T>,
	) => ReturnType<typeof TAURI_API_EVENT.once<T>>;
	emit: null extends T
		? (payload?: T) => ReturnType<typeof TAURI_API_EVENT.emit>
		: (payload: T) => ReturnType<typeof TAURI_API_EVENT.emit>;
};

export type Result<T, E> =
	| { status: "ok"; data: T }
	| { status: "error"; error: E };

function __makeEvents__<T extends Record<string, any>>(
	mappings: Record<keyof T, string>,
) {
	return new Proxy(
		{} as unknown as {
			[K in keyof T]: __EventObj__<T[K]> & {
				(handle: __WebviewWindow__): __EventObj__<T[K]>;
			};
		},
		{
			get: (_, event) => {
				const name = mappings[event as keyof T];

				return new Proxy((() => {}) as any, {
					apply: (_, __, [window]: [__WebviewWindow__]) => ({
						listen: (arg: any) => window.listen(name, arg),
						once: (arg: any) => window.once(name, arg),
						emit: (arg: any) => window.emit(name, arg),
					}),
					get: (_, command: keyof __EventObj__<any>) => {
						switch (command) {
							case "listen":
								return (arg: any) => TAURI_API_EVENT.listen(name, arg);
							case "once":
								return (arg: any) => TAURI_API_EVENT.once(name, arg);
							case "emit":
								return (arg: any) => TAURI_API_EVENT.emit(name, arg);
						}
					},
				});
			},
		},
	);
}
